module.exports = __webpack_public_path__ + "img/icon-gift-card.d61b5bcc.svg";